export enum TaxType {
  SalesTax = 1,
  Vat = 2,
}
